<template>
  <el-select
    v-model="value"
    multiple
    placeholder="Traffic quality"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

import {
  TrafficQualityLabels,
  TrafficQualityLabel,
  TrafficQuality
} from '@/api/types'

type TrafficEntry = {
  key: TrafficQuality
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'TrafficSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = TrafficQualityLabels.map<TrafficEntry>(
      (label: TrafficQualityLabel) => {
        return {
          key: label.id,
          label: label.label,
          disabled: false
        }
      }
    )

    const update = (newValue: TrafficQuality[]) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, options, value }
  }
})
</script>
